import { Icon as IconifyIcon } from "@iconify/react/offline";
import { ICON_MAP } from "./constants";
import type { IconName } from "./types";

type Props = { name: IconName; size?: React.CSSProperties["width"]; color?: React.CSSProperties["color"] } & Pick<
	React.HTMLAttributes<SVGElement>,
	"className" | "style"
>;

const Icon = ({ name, color, size = "16px", className }: Props): React.ReactNode => (
	<IconifyIcon icon={ICON_MAP[name]} width={size} height={size} color={color} className={className} />
);

export { Icon };
